export default __webpack_public_path__ + "static/media/21-2_star.7ce2f3bf.svg";